// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"538":"recorder","983":"profiler"}[chunkId] + "-" + {"538":"361ca0d8f34b9acb74d1","983":"41dafd0335f446aa7569"}[chunkId] + ".chunk.js";
};